import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Gantt, ViewMode } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";

import { connect } from "react-redux";
import { compose } from "redux";

//import { CSSTransition } from 'react-transition-group';

import { getDepartments, getDepartmentsAction, addActionComments, editActionComments } from "../../store/actions/departmentActions";
import {editActionProgress, editAction} from "../../store/actions/riskActions"; 

import debounce from "lodash/debounce";
import { Disable } from 'react-disable';


import "./Gantt.css";

import Select from 'react-select'


import ActionOverlay from "../../components/Action/ActionOverlay";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            // backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};





const GanttComponent = (props) => {

    /*
    const dummy = [{
        start: new Date(2024, 9, 15),
        end: new Date(2024, 9, 16),
        name: 'Risk Identification',
        id: 'Task 1',
        type: 'project',
        progress: 60,
        isDisabled: false,
        hideChildren: false,
        styles: { progressColor: '#007bff', progressSelectedColor: '#0056b3' },
        displayOrder: 1,

    },
    {
        start: new Date(2024, 9, 16),
        end: new Date(2024, 9, 17),
        name: 'Sub-task: Identify Potential Risks',
        id: '2',
        type: 'task',
        progress: 40,
        isDisabled: false,
        styles: { progressColor: '#6c757d', progressSelectedColor: '#5a6268' },
        project: 'Task 1',
        displayOrder: 2,
    },

    {
        start: new Date(2024, 9, 16),
        end: new Date(2024, 9, 17),
        name: 'Sub-task: Identify Potential Risks',
        id: 'dfdfdfSub-taskd 1.5',
        type: 'task',
        progress: 40,
        isDisabled: false,
        styles: { progressColor: '#6c757d', progressSelectedColor: '#5a6268' },
        project: 'Task 1',
        displayOrder: 3,
    }
    ];
*/

    const { departments, getDepartmentsFN, getDepartmentsActionFN, actions, addActionCommentsFN,editActionFN, editActionCommentsFN, activeDepartmentId, profile } = props;

    ////console.log("ACTIONS GANTT :", actions);
    // Step 1: Initialize state for input values
    const [tasks, setTasks] = useState([]);

    const [isLoading, setIsLoading] = useState(true);


    const [risk_id, setRiskId] = useState(null);
    const [isActionOpen, setIsActionOpen] = useState(false);
    const [action_id, setActionId] = useState(null);


    // const [taskDescription, setTaskDescription] = useState("");


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateServerData = useCallback(
        debounce((comment_iid, comments, department_id) => {
            // Make your API call here
            //alert(action_id);
            setIsLoading(true);
            editActionCommentsFN(comment_iid, comments, department_id);

            //alert("Sending data to server!!");
            // axios.post("/update-data", data); 
        }, 1500), // Adjust the debounce delay (1000 ms = 1 second)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );


    useEffect(() => {
        if (activeDepartmentId) {
            //alert(activeDepartmentId);
            if (profile.role !== "User") {
                getDepartmentsActionFN(activeDepartmentId);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeDepartmentId]);

    const departmentOptions = departments && departments.map(department => ({
        value: department.department_id,
        label: department.name
    }));

    const [activeDepartment, setActiveDepartment] = useState(activeDepartmentId ? activeDepartmentId : null);

    useEffect(() => {

        getDepartmentsFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {


        if (profile?.department_id && (profile.role === "User")) {
            //alert(profile.department_id);
            setActiveDepartment(profile.department_id);
            console.log(profile.department_id)
            getDepartmentsActionFN(profile.department_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile]);

    useEffect(() => {


        if (activeDepartmentId) {
           setActiveDepartment(activeDepartmentId)
            
        }
    }, [activeDepartmentId]);
    
    const ganttWrapperRef = useRef(null);

    useEffect(() => {
        if (ganttWrapperRef.current) {
            // Use timeout to wait for Gantt to finish its own scroll logic
            setTimeout(() => {
                ganttWrapperRef.current.scrollLeft = 0;
            }, 100); // 100ms usually works — adjust if needed
        }
    }, [tasks]); // Runs every time tasks change

    /*
    useEffect(() => {
        if (departments?.length > 0) {
            //alert(1)
            setActiveDepartment(departments[0].department_id);
            getDepartmentsActionFN(departments[0].department_id);
            //////console.log(departments[0].department_id, departments);
            //select first department
        }
    }, [departments]);

    */

    useEffect(() => {

        setTasks([]);



        if (actions?.length > 0) {



            let newTasks = actions.map(action => {

                //////console.log(action.iid);

                return {
                    ...action,
                    start: new Date(action.start),
                    end: new Date(action.end),
                    hideChildren: true
                }
            });
            //////console.log(newTasks);
            /*    setTimeout(() => {
                    setTasks(newTasks);
                    setInputValues(actions.map(task => task.type === 'comment' ? { [task.iid]: task.name } : {}));
                }, 500);
    */
            setTasks(newTasks);
            setIsLoading(false);
            //////console.log(actions);
            //////console.log(actions.map(task => task.type === 'comment' ? { [task.iid]: task.name } : {}));

            //////console.log(inputValues[2]);
        }

        else {
            setTasks([]);
        }
    }, [actions]);

    //const [collapsedTasks, setCollapsedTasks] = useState([]);
    const handleExpanderClick = (task) => {
        setTasks(tasks.map(t => (t.id === task.id ? task : t)));
        //setCollapsedTasks(collapsedTasks.map(t => (t.id === task.id ? task : t)));
        ////console.log("On expander click Id:" + task.id);

    };

    const handleAddTask = (task) => {
        ////console.log(task);

        addActionCommentsFN(task.iid, "New Comment", activeDepartment);


    };



    const closeAction = async (data, action_id) => {
        console.log("closeAction", activeDepartment)
        await updateControlServerData(data, action_id)
        getDepartmentsActionFN(activeDepartment);
        setIsActionOpen(false);
    }

    const openAction = (action) => {
        //console.log("action", action);
        if(!action.iid)
            return
        setActionId(action.iid);
        setRiskId(action.risk_id);
        setIsActionOpen(true);
    };


    const updateControlServerData = async (data, action_id) => {

        //console.log("ACTION DATA BEFORE ADJUSTMENT", data);

        // Clone data to avoid modifying state directly
        console.log("Action:", data, "action_id:", action_id)
        const updatedData = { ...data };

        // Add one day to StartDate and EndDate if they exist
        if (updatedData.StartDate) {
            const startDate = new Date(updatedData.StartDate);
            startDate.setDate(startDate.getDate() + 1);
            updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        if (updatedData.EndDate) {
            const endDate = new Date(updatedData.EndDate);
            endDate.setDate(endDate.getDate() + 1);
            updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        //console.log("ACTION DATA AFTER ADJUSTMENT", updatedData);

        setIsLoading(true);
        editActionFN(risk_id, action_id, updatedData);
        setIsLoading(false);
    }

    /*
     <input type="text" className="w-full bg-transparent"
                                            onKeyDown={(event) => {
                                                event.stopPropagation();
    
                                            }}
                                            id={item.iid}
                                            name={item.iid}
                                            key={item.iid}
                                            value={inputValues.find(input => input[item.iid])?.[item.iid] || ""}
                                            onChange={(event) => {
                                                handleInputChange(item.iid, event.target.value);
                                            }}
                                        />
    
                                        */











    const TaskListTable = React.memo(({
        tasks,
        rowWidth,
        rowHeight,
        onExpanderClick,
        handleAddTask,
        profile
    }) => {

        console.log("HELLO FROM TaskListTable");

        const [inputValues, setInputValues] = useState([]);


        const handleInputChange = (id, value) => {
            setInputValues(prevValues => {
                const updatedValues = prevValues.filter(input => !input[id]);
                return [...updatedValues, { [id]: value }];
            });
            updateServerData(id, value, activeDepartment);
        };

        useEffect(() => {
            if (tasks?.length > 0) {
                setInputValues(tasks.map(task => task.type === 'comment' ? { [task.iid]: task.name } : {}));
            }
        }, [tasks]);





        return (
            <div ref={ganttWrapperRef} style={{ overflowX: "auto", overflowY: "auto", width: "100%" }}>
            <div style={{ borderBottom: "0.5px solid #dfe1e5", borderLeft: "0.5px solid #dfe1e5" }}>
                {tasks.map((item, i) => {
                    let expanderSymbol = "";
                    if (item.hideChildren === false) {
                        expanderSymbol = "▼";
                    } else if (item.hideChildren === true) {
                        expanderSymbol = "▶";
                    }


                    const isProject = item.type === "project";
                    const isComment = item.type === "comment";


                    return (
                        <div
                            key={item.id}
                            style={{
                                boxSizing: "border-box",
                                height: rowHeight,
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                cursor: isProject ? "pointer" : "auto",
                                background: i % 2 === 0 ? "#ffffff" : "#f4f5f7",
                                padding: 10,
                                paddingLeft: isProject ? 10 : isComment ? 50 : 30
                            }}
                        >
                            <div
                                onClick={() => { onExpanderClick(item); }}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    margin: 0
                                }}
                            >
                                {isProject && <div
                                    className={
                                        expanderSymbol
                                            ? "taskListExpander"
                                            : "taskListEmptyExpander"
                                    }
                                    onClick={() => onExpanderClick(item)}
                                >
                                    {expanderSymbol}
                                </div>}




                                {isComment ? (



                                    <input type="text" className="w-full bg-transparent"
                                        onKeyDown={e => {
                                            e.stopPropagation();
                                        }}
                                        id={item.iid}
                                        name={item.iid}
                                        key={item.iid}
                                        value={inputValues.find(input => input[item.iid])?.[item.iid] || ""}
                                        onChange={(event) => {
                                            handleInputChange(item.iid, event.target.value);
                                        }}

                                    /*value={taskdescreipt2}
                                    onChange={(event) => {
                                        setTaskDescription2(event.target.value);
                                    }}*/
                                    />


                                ) : (
                                    <span>{item.name}</span>
                                )}

                            </div>
                            {
                                !isProject && item.type !== 'comment' && profile.role !== "Auditor" && (
                                    <div className="flex flex-row gap-2">

                                        <div
                                            className="flex justify-center items-center w-5 h-5 p-1 bg-gray-300 rounded cursor-pointer hover:bg-[#000] hover:bg-opacity-20"
                                            onClick={() => {

                                                openAction(item);
                                            }}
                                        >
                                            <i className="fa fa-pen" style={{ fontSize: 12 }}></i>
                                        </div>

                                        <div
                                            className="flex justify-center items-center w-5 h-5 p-1 bg-gray-300 rounded cursor-pointer hover:bg-[#000] hover:bg-opacity-20"
                                            onClick={() => {

                                                handleAddTask(item);
                                            }}
                                        >
                                            <i className="fa fa-plus" style={{ fontSize: 12 }}></i>

                                        </div>
                                    </div>

                                )
                            }




                        </div>
                    );
                })
                }
            </div >
            </div>
        );
        
    });

    const handleProgressChange = (task, progress) => {
        if (!task.iid) {
            console.error("Task IID is missing.");
            return;
        }
    
        ////console.log("Task being updated:", JSON.parse(JSON.stringify(task)));
    
        // Update the backend with the new progress value
        props.editActionProgressFN(task.iid, task.progress)
            .then((updatedAction) => {
                ////console.log("Progress updated successfully:", updatedAction);
    
                // Update tasks in state to reflect the new progress
                setTasks((prevTasks) =>
                    prevTasks.map((t) => (t.iid === task.iid ? { ...t, progress: task.progress } : t))
                );
            })
            .catch((error) => {
                console.error("Failed to update progress:", error);
                alert("Failed to update progress. Please try again.");
            });
    };

    return (
        <div className="w-full p-2 relative overflow-x-hidden" ref={ganttWrapperRef}>
            {/* Select box stays the same */}
            <div className="mb-4 w-64">
                {!activeDepartmentId && (profile.role === "Admin" || profile.role === "Auditor") && (
                    <Select
                        options={departmentOptions}
                        placeholder="Select a department"
                        onChange={(e) => {
                            setActiveDepartment(e.value);
                            getDepartmentsActionFN(e.value);
                        }}
                        styles={customStyles}
                        value={departmentOptions.find(department => department.value === activeDepartment)}
                    />
                )}
            </div>

            {tasks?.length > 0 ? (
                <div className="w-full overflow-x-auto">
                    <div style={{ display: "inline-flex", width: "max-content" }}>
                        <Disable disabled={isLoading}>
                            <Gantt
                                tasks={tasks}
                                viewMode={ViewMode.Day}
                                viewDate={new Date(new Date().setDate(new Date().getDate() - 7))}
                                listCellWidth="300px"
                                columnWidth={40}
                                rowHeight={50}
                                rowWidth={100}
                                fontSize="11px"
                                todayColor="rgba(255, 0, 0, 0.2)"
                                onClick={openAction}
                                onExpanderClick={handleExpanderClick}
                                onProgressChange={handleProgressChange}
                                // 👇 Force top header to only show day number
                                locale="en-GB"
                                dateTimeFormat={(date, viewMode) => {
                                    if (viewMode === ViewMode.Day) {
                                        return date.getDate().toString(); // just "8"
                                    }
                                    return date.toLocaleDateString("en-GB", { month: "short" }); // fallback for other views
                                }}
                            />
                        </Disable>
                    </div>
                </div>
            ) : (
                <div className="w-full h-50 flex justify-center items-center">
                    <span className="text-gray-500">No actions found</span>
                </div>
            )}

            <Popup
                open={isActionOpen}              
                contentStyle={{
                    overflow: 'auto',
                    maxHeight: '80vh',
                    width: '900px',
                    marginTop: '14vh'
                }}
            >
                <ActionOverlay
                    closeAction={closeAction}
                    risk_id={risk_id}
                    action_id={action_id}
                />
            </Popup>
        </div>
    );

};




const mapStateToProps = (state) => {
    console.log(state.department.actions)
    return {
        departments: state.department.departments,
        actions: state.department.actions,
        profile: state.profile.profile

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartmentsFN: () => dispatch(getDepartments()),
        getDepartmentsActionFN: (department_id) => dispatch(getDepartmentsAction(department_id)),
        addActionCommentsFN: (action_id, comments, department_id) => dispatch(addActionComments(action_id, comments, department_id)),
        editActionCommentsFN: (comment_iid, comments, department_id) => dispatch(editActionComments(comment_iid, comments, department_id)),
        editActionProgressFN: (action_id, progress) => dispatch(editActionProgress(action_id, progress)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(GanttComponent);
